<template>
    <div class="xiaotano">
        <banner ref="header"></banner>
        <div class="zhifuding">
            <div class="fanhuilist" @click="goOff()"><i class="el-icon-arrow-left"></i>返回</div>
            <div class="querandindan">确认订单信息</div>
            <div class="zhifuxinxi">
                <div style="margin-top: 30px;margin-left: 20px;">
                    <img style="width: 258px;height: 150px;border-radius: 4px;" :src="cover" alt="">
                </div>
                <div>
                    <div class="ershicp">{{name}}</div>
                    <div v-if="discount_price == null" class="qianshu">¥{{price}}</div>
                    <div v-if="discount_price != null" class="qianshu">¥{{discount_price}}</div>
                </div>
            </div>
            <div v-if="ext != null" class="tixing"><span>*</span>课程提醒发送至</div>
            <div v-if="ext != null" style="width: 800px;margin-left: 40px;margin-top: 20px;">
                <el-form :model="form" label-width="120px">
                    <div v-for="(item, index) in ext" :key="index" class="forxunhuan">
                        <el-form-item :label="item.name"
                            style="float: left;">
                            <div><el-input class="wentishuru" v-model="form[`custom${item.id}`]['value']" placeholder="请输入内容"></el-input></div>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div style="clear: both;"></div>
            <div class="zhifufs">选择支付方式</div>
            <div style="display: flex;margin-bottom: 40px;">
                <div v-for="(item,index) in zhifu" :key="index" @click="bbb(item,index)" v-bind:class="{zg:number === index}" style="width: 334px;
                height: 78px;margin-left: 40px;margin-top: 30px;border: 1px solid #dee2e9;">
                    <div style="display: flex;">
                         <div><img style="margin-top: 20px;margin-left: 85px;" :src="item.image" alt=""></div>
                         <div class="zhifuwzs" style="margin-top: 22px;margin-left: 20px;">{{ item.name }}</div>
                    </div>
                </div>
            </div>
            <!-- <button @click="zhifuzhong()">支付</button> -->
        </div>
        <div class="lijizhifu">
            <div class="shishizf">实付金额：</div>
            <div v-if="discount_price == null" class="zhifje">¥{{price}}</div>
            <div v-if="discount_price != null" class="zhifje">¥{{discount_price}}</div>
            <div><button class="lihifu" @click="payMoney">立即支付</button></div>
        </div>
        <div style="margin-top: 60px;height: 1px;"></div>
        <el-dialog
            :visible.sync="dialogVisible"
            width="604px"
            >
            <div v-if="discount_price == null" style="text-align: center;"><span class="ershifu">实付金额:</span><span class="erjine">¥{{ price }}</span></div>
            <div v-if="discount_price != null" style="text-align: center;"><span class="ershifu">实付金额:</span><span class="erjine">¥{{ discount_price }}</span></div>
            <canvas
                id="qrccode-canvas"
                class="xiaotan"
            ></canvas>
            <div class="weixinsaoma">{{zhifuwz}}</div>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span> -->
        </el-dialog>
        <!-- 尾部 -->
    <bottom></bottom>
    </div>
</template>
<script>
import QRCode from "qrcode";
import { debounce } from "@/utils";
import banner from './mofang/header.vue'
import bottom from './mofang/footer.vue'

let canvas = "";

export default {
    data() {
      return {
        cover:'',
        name: '',
        price: '',
        discount_price: '',
        ext: [],
        form: {},
        zhifu: [{image: 'https://tengface-live-user.oss-cn-shenzhen.aliyuncs.com/web/wx-user/img/weixinzf.png', name: '微信支付'},
        {image: 'https://tengface-live-user.oss-cn-shenzhen.aliyuncs.com/web/wx-user/img/zhifubaizf.png', name: '支付宝支付'}],
        number:0,
        dialogVisible: false,
        zhifuwz: '请打开微信扫码支付',
        rules: {},
        flag: '',
        opid: '',
        uid: '',
        order_no: ''
      } 
    },
    mounted() {
        const timer = setInterval(() => {
              this.checkOrderPayStatus();//你所加载数据的方法
 
        }, 5000)//秒查询一次是否登录
        //销毁定时器
         this.$once('hook:beforeDestroy', () => {
            clearInterval(timer)
        })
        console.log('sdgggggggggg', this.$route.params.setid)
        this.infolist()
        this.beforeCreate()
    },
    components: {
    banner,
    bottom
  },
    methods: {
        checkOrderPayStatus() {
            const data = {
                orderno:  this.order_no //'TF20230908169416163228b1736080'
            }
            this.$onlineApi.post('/payapi/checkOrderPayStatus', data)
            .then(res=>{
                if(res.data.code == 200) {
                  if(res.data.data == 'yes') {
                    this.$router.push({ path: `/Paymentsuccessful/${this.order_no}/${this.$route.params.setid}/${this.$route.params.kechengID}`})
                  }
                }
            })
        },
        goOff() {
            this.$router.go(-1)
        },
        handlePayRequest(money, order_no) {
            let data = {
                money: money,
                orderno:order_no,
                opid: this.opid,
                uid: this.uid,
                flag: this.flag,
            }
            if(localStorage.getItem('tengface_fans_id')) {
                data.fansid = localStorage.getItem('tengface_fans_id')
            }
            this.$onlineApi.post('/payapi/pcCartPay', data)
            .then(res=>{
                if(res.data.code == 200) {
                    this.zhifuerweima = res.data.data
                    this.$nextTick(function() {
                    // DOM操作
                    canvas = document.getElementById("qrccode-canvas");
                        this.createQrc(this.zhifuerweima);
                    });
                }
            })
        },
        payMoney: debounce(function() {
            this.zhifutank()
        }, 500),
        zhifutank() {
            if (this.ext != null) {
                    for(var i in this.form) {
                    if(i){
                        if(this.form[i].required == 1 && !this.form[i].value){
                            this.$message({
                                message: `请填写${this.form[i].name}`,
                                type: 'error'
                            })
                        return
                        }
                    }
                    }
                    const extObj = {}
                    for(let i in this.form) {
                    extObj[this.form[i].id] = this.form[i].value
                    }
                    console.log(extObj)
                    let data = {
                        goods_id: this.$route.params.setid,
                    }
                    if(localStorage.getItem('tengface_fans_id')) {
                        data.fans_id = localStorage.getItem('tengface_fans_id')
                    }
                    data = { ...data,...extObj }
                    this.$liveApi.post('/liveapi/api/goods/submitOrder', data)
                    .then(res=>{
                        if(res.data.code == 200) {
                            console.log(res.data.data)
                            this.order_no = res.data.data.order_no
                            this.dialogVisible = true
                            if(this.number === 0) {
                                this.zhifuwz = '请打开微信扫码支付'
                                this.flag = 1
                            } else {
                                this.zhifuwz = '请打开支付宝扫码支付'
                                this.flag = 3
                            }
                            this.handlePayRequest(res.data.data.money, res.data.data.order_no, this.flag)
                        }
                    })
                    
            } else {
                console.log('sgssssssssss', this.ext)
                const extObj = {}
                    for(let i in this.form) {
                    extObj[this.form[i].id] = this.form[i].value
                    }
                    console.log(extObj)
                    let data = {
                        goods_id: this.$route.params.setid,
                    }
                    if(localStorage.getItem('tengface_fans_id')) {
                        data.fans_id = localStorage.getItem('tengface_fans_id')
                    }
                    data = { ...data,...extObj }
                    this.$liveApi.post('/liveapi/api/goods/submitOrder', data)
                    .then(res=>{
                        if(res.data.code == 200) {
                            console.log(res.data.data)
                            this.dialogVisible = true
                            if(this.number === 0) {
                                this.zhifuwz = '请打开微信扫码支付'
                                this.flag = 1
                            } else {
                                this.zhifuwz = '请打开支付宝扫码支付'
                                this.flag = 3
                            }
                            this.handlePayRequest(res.data.data.money, res.data.data.order_no, this.flag)
                        }
                    })
            }
        },
        createQrc(item) {
            // http://192.168.1.6:9936/#/goodsDetail?id=16&uid=1208&platform=ali
            // http://192.168.1.6:9936/#/goodsDetail?id=16&uid=1208&platform=wx
            this.bannerUrl = item //this.wx_h5_url + '/#/goodsDetail?id=' + this.id +'&uid=' + this.uid + '&platform=ali'
            console.log('11111111111111', this.bannerUrl)
            QRCode.toCanvas(canvas, this.bannerUrl, error => {
                if (error) {
                // eslint-disable-next-line no-empty
                } else {
                }
            });
            
        },
        bbb(item,index){
            console.log('2234444444', item, index)
            this.se=item;
            this.number=index;
        },
        // zhifuzhong() {
        //     const customOption = []
        //     this.ext.forEach(item => {
        //         customOption.push({ option_id: item.id, value: this.form['custom' + item.id] })
        //     })
        //     console.log(JSON.stringify(customOption))
        // },
        infolist() {
            const data = {
                id: this.$route.params.setid, 
                ds_id: this.$store.state.user.org_id
            }
            if(localStorage.getItem('tengface_fans_id')) {
                data.fans_id = localStorage.getItem('tengface_fans_id')
            }
            this.$liveApi.post('/liveapi/api/goods/info', data)
            .then(res=>{
                if(res.data.code == 200) {
                  console.log(res.data.data)
                  this.cover = res.data.data.cover
                  this.name = res.data.data.name
                  this.price = res.data.data.price
                  this.discount_price = res.data.data.discount_price
                  if (res.data.data.ext != null) {
                    this.ext = JSON.parse(res.data.data.ext)
                  } else {
                    this.ext = res.data.data.ext
                  }
                  this.opid = res.data.data.opid
                  this.uid = res.data.data.uid
                    if(this.ext != null) {
                    this.ext.forEach(item => {
                        this.$set(this.form, 'custom' + item.id, {value:'',required:item.required, name:item.name, id:item.id})
                    })
                  }
                    // this.getOrgPayConfig()
                }
            })
        },
        // getOrgPayConfig() {
        //     const data = {
        //         opid: 70
        //     }
        //     this.$axios.post('https://online.wanzibook.com/payapi/common/getOrgPayConfig', data)
        //     .then(res=>{
        //         if(res.data.code == 200) {
        //             this.wxappid = res.data.data.wxappid
        //         }
        //     })
        // },
        beforeCreate() {
            document.querySelector('body').style.background = '#f5f6f7'
        },
    }
}
</script>
<style scoped>
.xiaotano >>> .el-dialog {
    border-radius: 16px;
}
.weixinsaoma {
    font-size: 16px;
    font-family: PingFangSC-Regular;
    text-align: center;
    color: #20242f;
}
.xiaotan {
    width: 280px !important; 
    height: 280px !important;
    margin-left: 140px;
    margin-top: 9px;
}
.erjine {
    font-size: 24px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    color: #ff3700;
    margin-left: 10px;
}
.ershifu {
    font-size: 22px;
    font-family: PingFangSC-Regular;
    color: #20242f;
}
.lihifu {
    width: 232px;
    height: 62px;
    background: #ff571f;
    border-radius: 4px;
    border: none;
    font-size: 24px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    color: #ffffff;
    margin-left: 677px;
    margin-top: 48px;
}
.zhifje {
    font-size: 24px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    color: #ff3700;
    line-height: 158px;
    margin-left: 9px;
}
.shishizf {
    font-size: 26px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    color: #202020;
    line-height: 158px;
    margin-left: 40px;
}
.zhifuwzs {
    font-size: 26px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    color: #202020;
}
.zg {
    border: 2px solid #42b034 !important;
}
.wxzhifu {
    width: 308px;
    height: 78px;
    background: #ffffff;
    border: 1px solid #dee2e9;
    /* margin-left: 40px;
    margin-top: 30px;
    margin-bottom: 40px; */
}
.zhifufs {
    font-size: 20px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    color: #202020;
    margin-left: 40px;
    margin-top: 20px;
}
.forxunhuan >>> .el-form-item__label {
    color: #202020;
}
.wentishuru {
    width: 260px;
    height: 36px;
    background: #ffffff;
    /* border: 1px solid #eaebec; */
    border-radius: 2px;
}
.tixing span {
    color:  #ff5227;
}
.tixing {
    margin-left: 40px;
    margin-top: 20px;
    font-size: 20px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    color: #202020;
}
.qianshu {
    font-size: 20px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    color: #ff3700;
    margin-left: 22px;
    margin-top: 80px;
}
.ershicp {
    font-size: 24px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    color: #4d4d4d;
    margin-left: 20px;
    margin-top: 30px;
}
.zhifuxinxi {
    width: 1180px;
    height: 210px;
    background: #ffffff;
    border: 1px solid #e8eaec;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
}
.querandindan {
    font-size: 20px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    color: #202020;
    margin-top: 33px;
    margin-left: 40px;
}
 .fanhuilist {
    font-size: 16px;
    font-family: PingFangSC-Regular;
    color: #4d4d4d;
    margin-top: 20px;
    margin-left: 35px;
    cursor: pointer;
 }
 .zhifuding {
    width: 1260px;
    height: 100%;
    background: #ffffff;
    border-radius: 1px;
    margin: 0 auto;
    margin-bottom: 20px;
    margin-top: 20px;
    overflow: hidden;
 }
 .lijizhifu {
    width: 1260px;
    height: 158px;
    background: #ffffff;
    border: 1px solid #e8eaec;
    border-radius: 1px;
    margin: 0 auto;
    margin-bottom: 20px;
    overflow: hidden;
    display: flex;
 }
</style>